import { render, staticRenderFns } from "./StorekeeperDashboard.vue?vue&type=template&id=22ddf093&scoped=true"
import script from "./StorekeeperDashboard.vue?vue&type=script&lang=js"
export * from "./StorekeeperDashboard.vue?vue&type=script&lang=js"
import style0 from "./StorekeeperDashboard.vue?vue&type=style&index=0&id=22ddf093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ddf093",
  null
  
)

export default component.exports